import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect, ConnectedProps } from 'react-redux';
import { ErrorStatus } from '@tink/core/src/tinkLinkErrorCodes';
import { SuccessOverlay } from '../../../core/screens/SuccessNotification/molecules/SuccessOverlay/SuccessOverlay';
import { ERR_USER_CANCELLED } from '../../../utilities/error';
import { setApplicationError as setApplicationErrorConnect } from '../../../stores/app-state-store';

import { timerUtils, WaitTimer } from '../../../utilities/timer';
import { messages } from './messages';

export type ExitFeedbackProps = PropsFromRedux & {
  showThankYouMessage: boolean;
  waitTimer?: WaitTimer;
};

export const ExitFeedbackPresenter: React.FC<ExitFeedbackProps> = ({
  showThankYouMessage,
  setApplicationError,
  waitTimer = timerUtils.waitTimer,
}) => {
  useEffect(() => {
    const redirectBackToClient = async () => {
      if (showThankYouMessage) {
        await waitTimer(3000);
      }

      setApplicationError({
        ...ERR_USER_CANCELLED,
        errorStatus: ErrorStatus.USER_CANCELLED_WITH_ALTERNATE_FLOW,
      });
    };

    redirectBackToClient();
  }, [setApplicationError, showThankYouMessage, waitTimer]);

  if (!showThankYouMessage) {
    return null;
  }

  return <SuccessOverlay text={<FormattedMessage {...messages.successHeading} />} redirectUri="" />;
};

const mapDispatchToProps = {
  setApplicationError: setApplicationErrorConnect,
};

const connector = connect(undefined, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export const ExitFeedback = connector(ExitFeedbackPresenter);
